import fileSys from "../../fileoprators/fileSystem";
import { isDefined } from "../shared";
const PRINT_CONSOLE = true;
const int2bool = Symbol("int2bool");

class RGPAPI {
  constructor() {
    if (!window.__ct__.debug) {
      this.addon = window.require(fileSys.getUtilPath("DEA520RGP.node"));
    }
  }

  [int2bool](val) {
    return val === 0;
  }
  /**
   * 初始化
   * 返回对象 {ptr,ptrCornea,ptrLens,ptrLensz}
   * @param {*} cartFullPath 病例CRNF.CART全路径
   * @param {*} acFullPath 病例AC.ANA全路径
   */
  initfCorneaLensData(cartFullPath, acFullPath) {
    if (!isDefined(this.addon)) return;

    let obj = this.addon.InitfCorneaLensData(cartFullPath, acFullPath);
    if (PRINT_CONSOLE) {
    }
    return obj;
  }

  /**
   * 初始化渲染器
   * 返回渲染器句柄
   * @param {*} winW 窗口宽度
   * @param {*} winH 窗口高度
   * @param {*} dataW 数据宽
   * @param {*} dataH 数据高
   * @param {*} posPngFullPath pos.png图片全路径
   */
  renderer3DInit(winW, winH, dataW, dataH, posPngFullPath) {
    if (!isDefined(this.addon)) return;

    let ptr = this.addon.Renderer3DInit(winW, winH, dataW, dataH, posPngFullPath);
    if (PRINT_CONSOLE) {
    }
    return ptr;
  }

  /**
   * 更新两个表面的顶点数据z-map
   * 返回bool
   * @param {*} ptrRender 渲染器句柄
   * @param {*} ptrCornea 角膜前表面数据
   * @param {*} ptrLens 角膜后表面数据
   */
  renderer3DUpdateVertices(ptrRender, ptrCornea, ptrLens) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.Renderer3DUpdateVertices(ptrRender, ptrCornea, ptrLens);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }

  /**
   * 适配弧内莫个环带直径下平抖k e
   * 返回bool
   * @param {*} sagfrout 病例SAGF.CART全路径
   * @param {*} dia 2~12
   * @param {*} flatBuffer Float64Array 1.平k轴位 2.平k值 3.平轴ecc 4.平轴k（Q）值
   * @param {*} steepBuffer Float64Array 1.陡位 2.陡k值 3.陡轴ecc 4.陡轴k（Q）值
   */
  calcSFecckOneDia(sagfrout, dia, flatBuffer, steepBuffer) {
    if (!isDefined(this.addon)) return;

    let result = this.addon.CalcSFecckOneDia(sagfrout, dia, flatBuffer, steepBuffer);
    if (PRINT_CONSOLE) {
    }
    return result;
  }

  /**
   *
   * 返回bool
   * @param {*} ptr
   * @param {*} dia 2~12
   * @param {*} out360buffer Float64Array 长度为360
   */
  calcRiseArch(ptr, dia, out360buffer) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.CalcRiseArch(ptr, dia, out360buffer);
    if (PRINT_CONSOLE) {
    }
    return result;
  }

  /**
   * 镜表面生成
   * 返回bool
   * @param {*} ptr
   * @param {*} radiusBuffer 每段弧半径
   * @param {*} widthBuffer 宽度
   * @param {*} eccBuffer ecc
   * @param {*} length 弧段数
   */
  lensSurfaceProduce(ptr, radiusBuffer, widthBuffer, eccBuffer, length) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.LensSurfaceProduce(ptr, radiusBuffer, widthBuffer, eccBuffer, length);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }

  /**
   * 生成坐标变换矩阵
   * 返回bool
   * @param {*} ptr
   * @param {*} transMatrixBuffer Float32Array 镜片变换矩阵
   * @param {*} x
   * @param {*} y
   * @param {*} offsetZ
   * @param {number} [rotzAngle=0]
   * @memberof Mock
   */
  genTransMatrix(ptr, transMatrixBuffer, x, y, offsetZ, rotzAngle = 0) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.GenTransMatrix(ptr, transMatrixBuffer, x, y, offsetZ, rotzAngle);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }

  /**
   * 更新镜片的变换矩阵
   * 返回bool
   * @param {*} ptrRender 渲染器句柄
   * @param {*} transMatrixBuffer Float32Array 镜片变换矩阵
   * @memberof Mock
   */
  renderer3DUpdateTransform(ptrRender, transMatrixBuffer) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.Renderer3DUpdateTransform(ptrRender, transMatrixBuffer);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }

  /**
   * 窗口渲染重绘,同时可以得到泪液厚度图
   * 厚度图1为镜片投影方向的泪液厚度图
   * 厚度图2为角膜投影方向的泪液厚度图
   * 返回bool
   * @param {*} ptrRender 渲染器句柄
   * @param {*} depth1Buffer 厚度图1数据内存指针,可为null
   * @param {*} depth2Buffer 厚度图2数据内存指针,可为null
   * @param {*} bufLength 内存大小,不需要回传厚度图时,为0
   * @memberof Mock
   */
  renderer3DDraw(ptrRender, depth1Buffer, depth2Buffer, bufLength) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.Renderer3DDraw(ptrRender, depth1Buffer, depth2Buffer, bufLength);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }

  /**
   * 二维图像中镜片边界
   *
   * @param {*} ptrRender 渲染器句柄
   * @param {*} transMatrixBuffer Float32Array 镜片变换矩阵
   * @param {*} dataXBuffer Float64Array
   * @param {*} dataYBuffer Float64Array
   * @param {*} dataLen dataX和dataY长度,为360
   * @return {*}
   * @memberof RGPAPI
   */
  lensEdgein2Dimension(ptrRender, transMatrixBuffer, dataXBuffer, dataYBuffer, dataLen) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.LensEdgein2Dimension(
      ptrRender,
      transMatrixBuffer,
      dataXBuffer,
      dataYBuffer,
      dataLen
    );
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }
  /**
   * 获取某一截面泪液厚度
   *
   * @param {*} depth1Buffer 角膜视角下的泪液厚度数据,厚度图1数据
   * @param {*} rotateAngle
   * @param {*} lensr
   * @param {*} thickoutBuffer Float64Array
   * @return {*}
   * @memberof RGPAPI
   */
  intersectionTearthick(depth1Buffer, rotateAngle, lensr, thickoutBuffer) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.IntersectionTearthick(depth1Buffer, rotateAngle, lensr, thickoutBuffer);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }
  /**
   * 用户鼠标输入,用于3D显示交互
   * 返回bool
   * @param {*} ptrRender 渲染器句柄
   * @param {*} winW 窗口宽度
   * @param {*} winH 窗口高度
   * @param {*} mouseX 鼠标坐标X
   * @param {*} mouseY 鼠标坐标Y
   * @param {*} event 鼠标事件,0-MouseUp,1-MouseDown,2-MouseMove
   * @memberof Mock
   */
  renderer3DUserMouseEvent(ptrRender, winW, winH, mouseX, mouseY, event) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.Renderer3DUserMouseEvent(ptrRender, winW, winH, mouseX, mouseY, event);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }
  okLensRecommend(s, c, k1, k2, e, w2w, del, output5) {
    if (!isDefined(this.addon)) return false;
    let result = this.addon.OKLensRecommend(s, c, k1, k2, e, w2w, del, output5.buffer);
    if (PRINT_CONSOLE) {
    }
    return result;
  }
  contactLensRecommend1(s, c, k1, k2, km, w2w, output3) {
    if (!isDefined(this.addon)) return false;
    let result = this.addon.ContactLensRecommend1(s, c, k1, k2, km, w2w, output3.buffer);
    if (PRINT_CONSOLE) {
    }
    return result;
  }
  contactLensRecommend2(s, c, k1, k2, w2w, output3) {
    if (!isDefined(this.addon)) return false;
    let result = this.addon.ContactLensRecommend2(s, c, k1, k2, w2w, output3.buffer);
    if (PRINT_CONSOLE) {
    }
    return result;
  }
  contactLensRecommend3(s, c, k1, k2, simk1, ecc, w2w, output4) {
    if (!isDefined(this.addon)) return false;
    let result = this.addon.ContactLensRecommend3(s, c, k1, k2, simk1, ecc, w2w, output4.buffer);
    if (PRINT_CONSOLE) {
    }
    return result;
  }
  contactLensRecommend4(s, c, k1, k2, simk1, simk2, ecc1, ecc2, w2w, output5) {
    if (!isDefined(this.addon)) return false;
    let result = this.addon.ContactLensRecommend4(
      s,
      c,
      k1,
      k2,
      simk1,
      simk2,
      ecc1,
      ecc2,
      w2w,
      output5.buffer
    );
    if (PRINT_CONSOLE) {
    }
    return result;
  }
  /**
   * 释放渲染器
   * 返回bool
   * @param {*} ptrRender
   * @memberof Mock
   */
  renderer3DRelease(ptrRender) {
    if (!isDefined(this.addon)) return;
    let result = this.addon.Renderer3DRelease(ptrRender);
    if (PRINT_CONSOLE) {
    }
    return this[int2bool](result);
  }

  /**
   * 释放
   * 无返回
   * @param {*} ptr
   * @memberof Mock
   */
  freeCorneaLensData(ptr) {
    if (!isDefined(this.addon)) return;
    this.addon.FreeCorneaLensData(ptr);
    if (PRINT_CONSOLE) {
    }
  }
}

const RgpApi = new RGPAPI();
export default RgpApi;



// WEBPACK FOOTER //
// ./src/topography/js/RGPAPI.js